var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisCopierWord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,21.4H8.3V6.8h11.5 M19.8,4.7H8.3c-1.2,0-2.1,0.9-2.1,2.1v14.6c0,1.2,0.9,2.1,2.1,2.1h11.5c1.2,0,2.1-0.9,2.1-2.1V6.8 C21.9,5.6,21,4.7,19.8,4.7 M16.7,0.5H4.2C3,0.5,2.1,1.4,2.1,2.6v14.6h2.1V2.6h12.5V0.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,10.6v0.2c-0.2,0-0.3,0-0.5,0.1c-0.2,0-0.3,0.2-0.3,0.4c0,0.1,0,0.2,0,0.2l0.1,0.3l1.7,4.4l1.2-3.3l-0.5-1.4 c-0.1-0.2-0.2-0.4-0.5-0.5c-0.2-0.1-0.4-0.1-0.6-0.1v-0.2h3.1v0.2c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.1,0,0.1,0,0.2 c0,0.1,0.1,0.2,0.1,0.3l1.7,4.4l1.5-4c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0-0.2,0-0.2c0-0.2-0.1-0.4-0.3-0.4c-0.2-0.1-0.3-0.1-0.5-0.1 v-0.2h2.4v0.2c-0.2,0-0.3,0.1-0.5,0.2c-0.2,0.1-0.4,0.3-0.5,0.6L17.4,15l-0.5,1.3l-0.7,2.1H16l-0.5-1.3l-1.4-3.6l-1.8,4.9h-0.2 L11.3,16l-1-2.7c-0.2-0.7-0.5-1.4-0.9-2.1C9.3,11,9,10.8,8.7,10.8v-0.2L11.5,10.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisCopierWord);
export default __webpack_public_path__ + "static/media/action_gris_copier-word.dd018ece.svg";
export { ForwardRef as ReactComponent };